import React, { useRef } from "react";
import "./ManagePartners.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import refillEye from "../../../../assests/refillEye.svg";
import searchIcon from "../../../../assests/search.svg";
import emotions7 from "../../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import LoadingSpinner from "../../../Loading/component";
import CircularProgress from "@mui/material/CircularProgress";
import { FaPlus } from "react-icons/fa";

const ManagePartnersComponent = (props) => {
  const navigate = useNavigate();
  const searchInputRef = useRef(null);

  const handleGoBack = () => {
    navigate("/");
  };

  const handleClearSearch = () => {
    props.handleClearSearch();
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };
  
  // Cohort type mapping
  const cohortTypeMapping = {
    "2": "FOFO(Franchise)",
    "4": "FOCO(City)",
    "13": "PDF"
  };

  // Function to get display type
  const getDisplayType = (partner) => {
    if (partner.cohortTypeId && cohortTypeMapping[partner.cohortTypeId]) {
      return cohortTypeMapping[partner.cohortTypeId];
    }
    return partner.type || partner.cohortTypeId || '-';
  };

  // ✅ FIXED: Get badge class based on type with null/undefined check
  const getBadgeClass = (type) => {
    // Convert to string and handle null/undefined
    const typeStr = String(type || '');
    
    if (typeStr.includes("FOFO")) return "mp-type-badge mp-type-badge-fofo";
    if (typeStr.includes("FOCO")) return "mp-type-badge mp-type-badge-foco";
    if (typeStr.includes("PDF")) return "mp-type-badge mp-type-badge-pdf";
    return "mp-type-badge mp-type-badge-default";
  };

  return (
    <div className="mp-main-wrapper">
      {/* Sidebar */}
      <div className="mp-sidebar-container">
        <Sidebar />
      </div>
      
      {/* Main Content */}
      <div className="mp-content-wrapper">
        {/* Header */}
        <div className="mp-header">
          <button className="mp-back-btn" onClick={handleGoBack} aria-label="Go back">
            <img src={leftArrow} alt="Back" />
          </button>
          <h1 className="mp-title">Manage Partners </h1>
        </div>

        {/* Controls */}
        <div className="mp-controls">
          <div className="mp-search-wrapper">
            <input
              ref={searchInputRef}
              type="search"
              className="mp-search-input"
              placeholder="Search by Partner Name, ID, Cohort ID, Owner ID"
              value={props.searchValue}
              onChange={props.handleSearchInputChange}
              onKeyPress={props.handleKeyPress}
              disabled={props.isLoading}
              aria-label="Search partners"
            />
            {props.searchValue ? (
              <button
                className="mp-clear-btn"
                onClick={handleClearSearch}
                disabled={props.isLoading}
                aria-label="Clear search"
              >
                ×
              </button>
            ) : (
              <button
                className="mp-search-btn"
                onClick={props.handleSearchSubmit}
                disabled={props.isLoading}
                aria-label="Search"
              >
                <img src={searchIcon} alt="Search" />
              </button>
            )}
          </div>

          <button
            className="mp-add-btn"
            onClick={props.handleAddNewEntry}
            disabled={props.isLoading}
          >
            <FaPlus className="mp-add-icon" />
            Add New
          </button>
        </div>

        {/* Table Section */}
        <div className="mp-table-section">
          <div className="mp-table-wrapper">
            <Table className="mp-table" striped hover>
              <thead>
                <tr>
                  <th className="mp-col-id">ID</th>
                  <th className="mp-col-name">Name</th>
                  <th className="mp-col-desc">Description</th>
                  <th className="mp-col-type">Type</th>
                  <th className="mp-col-cohort">Cohort ID</th>
                  <th className="mp-col-owner">Owner ID</th>
                  <th className="mp-col-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                {props.partnersList && props.partnersList.length > 0 ? (
                  props.partnersList.map((partner) => {
                    const displayType = getDisplayType(partner);
                    const badgeClass = getBadgeClass(displayType);
                    
                    return (
                      <tr 
                        key={partner.id} 
                        className="mp-table-row"
                        onClick={() => props.handleViewDetails(partner.id, partner.cohortId)}
                      >
                        <td className="mp-col-id">{partner.id}</td>
                        <td className="mp-col-name">
                          <strong>{partner.name}</strong>
                        </td>
                        <td className="mp-col-desc">
                          {partner.description || "-"}
                        </td>
                        <td className="mp-col-type">
                          <span className={badgeClass}>{displayType}</span>
                        </td>
                        <td className="mp-col-cohort">{partner.cohortId || "-"}</td>
                        <td className="mp-col-owner">{partner.ownerId || "-"}</td>
                        <td className="mp-col-actions">
                          <img
                            className="mp-view-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              props.handleViewDetails(partner.id, partner.cohortId);
                            }}
                            src={refillEye}
                            alt="View Details"
                            title="View Details"
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="7" className="mp-empty-state">
                      <div className="mp-empty-content">
                        <img
                          className="mp-empty-image"
                          src={emotions7}
                          alt="No partners found"
                        />
                        <h3 className="mp-empty-title">
                          {props.isSearching || props.searchValue ? 
                            "No Results Found" : 
                            "No Partners Found"}
                        </h3>
                        <p className="mp-empty-subtitle">
                          {props.isSearching || props.searchValue ? 
                            "Try adjusting your search" : 
                            "Create your first partner to get started"}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          {/* Load More */}
          {props.hasMore && !props.searchValue && !props.isSearching && (
            <div className="mp-load-more-container">
              <button
                className="mp-load-more-btn"
                onClick={props.handleLoadMore}
                disabled={props.isLoading}
              >
                {props.isLoading ? "Loading..." : "Load More"}
              </button>
            </div>
          )}

          {/* Search Results Info */}
          {props.searchValue && props.partnersList.length > 0 && (
            <div className="mp-search-info">
              Showing {props.partnersList.length} result(s) for "{props.searchValue}"
            </div>
          )}

          {/* No More Results */}
          {props.searchValue && !props.hasMore && props.partnersList.length > 0 && (
            <div className="mp-no-more-info">
              No more results found
            </div>
          )}
        </div>

        {/* Loading Overlay */}
        {props.isLoading && !props.isSearching && !props.searchValue && (
          <div className="mp-loading-overlay">
            <LoadingSpinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ManagePartnersComponent;